import { Typography } from "@mui/material"
import { styled } from "@mui/system"
import PropTypes from "prop-types"
import React from "react"

const StyledTitle = styled(Typography)(({ theme }) => ({
  minWidth: "150px",
  textAlign: "center",
  fontWeight: 600,
  color: "#1f007a",
  letterSpacing: "-0.05em",
  [theme.breakpoints.down("sm")]: {
    minWidth: "auto",
  },
}))

const PageTitle = ({ children, ...props }) => {
  return (
    <StyledTitle component="h2" {...props}>
      {children}
    </StyledTitle>
  )
}

PageTitle.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.string,
}

PageTitle.defaultProps = {
  variant: "h2",
}

export default React.memo(PageTitle)
